import Vue from "vue";
import Theme from "theme-vue";
let Th = new Theme();
Vue.prototype.$Th = Th;
let color =
  localStorage.getItem("--primary").indexOf("rgb") > -1
    ? "#009DF5"
    : localStorage.getItem("--primary");
Th.changeTheme(color);
